import { cometFetch } from './cometFetch';
import { REFEREE_ASSIGNMENTS_PATH } from './constants';
import type { CometFetchOptions, RefereeTeam } from './types';

type GetRefereeTeamsArgs = CometFetchOptions & {
  competitionId: string | number | null | undefined;
};

/**
 * GET {base}/referee-assignments/competitions/{competitionId}/teams
 *
 * Populates the team dropdown once a competition is selected. Called client-side
 * via the proxy (pass `baseUrl: COMET_PROXY_BASE`). Returns `null` when no
 * competition is selected or the request fails.
 */
export const getRefereeTeams = ({
  competitionId,
  baseUrl,
}: GetRefereeTeamsArgs) => {
  if (
    competitionId === null ||
    competitionId === undefined ||
    competitionId === ''
  ) {
    return Promise.resolve<RefereeTeam[] | null>(null);
  }

  const id = encodeURIComponent(String(competitionId));
  return cometFetch<RefereeTeam[]>(
    `${REFEREE_ASSIGNMENTS_PATH}/competitions/${id}/teams`,
    { baseUrl, revalidate: 300 }
  );
};
